<template>
  <v-form>
    <v-row align="center" justify="center">
      <h3><b>{{$t('json.statusbarsett')}}</b></h3>
    </v-row>
    <v-row align="center" justify="center">
      <v-col :cols="3">
        <v-text-field clearable v-model="BatchSettings.StatusBar.Color" @change="onChange" :disabled="disable || preview" :label="$t('json.barcolor')"></v-text-field>
      </v-col>
      <v-col :cols="4">
        <v-text-field clearable v-model="BatchSettings.StatusBar.Info" @change="onChange" :disabled="disable || preview" :label="$t('json.barinfo')"></v-text-field>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
export default {
  name: 'StatusBarSettings',
  props: {
    props: {
      type: Object,
      default: null
    },
    disable: {
      type: Boolean,
      default: false
    },
    preview: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
    }
  },
  computed: {
    BatchSettings () {
      return this.props
    }
  },
  methods: {
    async onChange (val) {
      this.$emit('changeSettings')
    }
  }
}
</script>
